import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Route guard: unauthenticated traffic never mounts app surfaces.
export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const { pathname, search } = useLocation();
  if (loading) {
    return (
      <div className="min-h-[60dvh] grid place-items-center" data-testid="auth-guard-loading">
        <span className="label-mono text-neutral-500">CHECKING SIGN-IN…</span>
      </div>
    );
  }
  if (!user) {
    const next = encodeURIComponent(pathname + search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return children;
}
